import { render, staticRenderFns } from "./EngravingElements.vue?vue&type=template&id=122e2c61&scoped=true"
import script from "./EngravingElements.vue?vue&type=script&lang=js"
export * from "./EngravingElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e2c61",
  null
  
)

export default component.exports